import { useReportRealEstateMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import HTransformObject from "@rf-helper/transform-object.helper";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";
import MxFormSubTitleAndDescription from "@rf-l1/page/form/MxFormSubTitleAndDescription";
import MxFormL3TextAreaField from "@rf-l3/form/MxFormL3TextAreaField";
import useModal from "@rf/base/modal/useModal";
import { FormProvider, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { IReportPropertyArgs } from "../util/model";
import {
  ReportPropertySchema,
  CReportProperty,
  CReportPropertyKeys,
  IReportPropertySchema
} from "../util/reportPropertySchema";
import { HToastCatchServerError } from "@rf-helper/cath-error-server";
import MxFormL3CheckBoxField from "@rf-l3/form/MxFormL3CheckBoxField";

export const ReportPropertyTemplateModal = () => {
  const { getData, onConfirm } = useModal();
  const { propertyId } = getData() as IReportPropertyArgs;
  const [reportProperty, { isLoading }] = useReportRealEstateMutation();

  const form = useForm<IReportPropertySchema>({
    resolver: yupResolver(ReportPropertySchema),
    defaultValues: { ...CReportProperty, id: propertyId.toString() }
  });

  const onSubmit = (data: IReportPropertySchema) => {
    const body = HTransformObject(
      {
        id: data.id,
        reportImage: data.reportImage ? 1 : 0,
        reportDescription: data.reportDescription ? 1 : 0,
        reportDocuments: data.reportDocuments ? 1 : 0,
        propertyNotAvailable: data.propertyNotAvailable ? 1 : 0,
        reportLocation: data.reportLocation ? 1 : 0,
        comment: data.comment
      },
      {
        removeUndefined: true,
        removeEmptyArray: true,
        removeNull: true,
        removeEmptyStrings: true,
        removeEmptyObjects: true
      }
    );

    const response = reportProperty({ body }).unwrap();

    toast
      .promise(response, {
        loading: "Enviando reporte...",
        success: "Reporte enviado correctamente",
        error: "Ha ocurrido un error al enviar el reporte"
      })
      .then(() => {
        onConfirm();
      })
      .catch(e => HToastCatchServerError(e));
  };

  return (
    <MxModalTemplate2>
      <Grid container rowGap={2}>
        <Grid item xs={12} mt={0} mb={0}>
          <MxFormSubTitleAndDescription
            label="Seleccione los motivos por la cual se reportará la propiedad"
            description=""
          />
        </Grid>

        <Grid item xs={12}>
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <Grid container rowGap={2} columnSpacing={2}>
                <Grid item xs={12}>
                  <MxFormL3CheckBoxField
                    withreacthookform={1}
                    name={CReportPropertyKeys.reportImage}
                    label="Reportar imágenes"
                  />
                </Grid>

                <Grid item xs={12}>
                  <MxFormL3CheckBoxField
                    withreacthookform={1}
                    name={CReportPropertyKeys.reportDescription}
                    label="Reportar descripción"
                  />
                </Grid>

                <Grid item xs={12}>
                  <MxFormL3CheckBoxField
                    withreacthookform={1}
                    name={CReportPropertyKeys.reportDocuments}
                    label="Reportar documentos"
                  />
                </Grid>

                <Grid item xs={12}>
                  <MxFormL3CheckBoxField
                    withreacthookform={1}
                    name={CReportPropertyKeys.reportLocation}
                    label="Reportar ubicación"
                  />
                </Grid>

                <Grid item xs={12}>
                  <MxFormL3CheckBoxField
                    withreacthookform={1}
                    name={CReportPropertyKeys.propertyNotAvailable}
                    label="Propiedad no disponible"
                  />
                </Grid>

                <Grid item xs={12}>
                  <MxFormL3TextAreaField
                    withreacthookform={1}
                    name={CReportPropertyKeys.comment}
                    label="Comentario"
                    placeholder="Agregue un comentario"
                  />
                </Grid>

                <ButtonsFooter isLoading={isLoading} />
              </Grid>
            </form>
          </FormProvider>
        </Grid>
      </Grid>
    </MxModalTemplate2>
  );
};

const ButtonsFooter = ({ isLoading }: { isLoading: boolean }) => {
  const { onClose } = useModal();
  return (
    <Grid container item xs={12}>
      <Grid item flex={1} />
      <Grid container item xs="auto" gap={2}>
        <Grid item xs="auto">
          <MxButton2
            testId="cancel-report-property-button"
            variant="contained"
            color="error"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancelar
          </MxButton2>
        </Grid>
        <Grid item xs="auto">
          <MxButton2
            testId="report-property-button"
            variant="contained"
            color="primary"
            type="submit"
            disabled={isLoading}
          >
            Enviar
          </MxButton2>
        </Grid>
      </Grid>
    </Grid>
  );
};
